import Vue from 'vue'

export default {  
  getCurrentBranch ({ commit }, branchUid) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$api.branches().show(branchUid)
        .then(branch => {
          commit('set_current_branch', branch.data)  
          resolve(branch)
        }).catch(err => {
          reject(err)
        })
    })
  },
}
